import { RETRY_COUNT } from "@impero-com/common/utils/query_client";

import { useGetTimezones } from "api/generated/constants/constants";

export const useTimezoneListQuery = () =>
    useGetTimezones({
        query: {
            select: (response) => response.data,
            retry: RETRY_COUNT,
        },
    });
